import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/articles';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group cursor-pointer">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-vip-crown-line text-lg text-background-50"></i>
            </div>
            <span className={`font-heading text-xl font-semibold whitespace-nowrap transition-colors ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
            }`}>
              {siteInfo.name}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {[
              { path: '/', label: '首页' },
              { path: '/category/platform-recommend', label: '平台推荐' },
              { path: '/category/bonus-guide', label: '领取攻略' },
              { path: '/category/platform-review', label: '平台评测' },
              { path: '/about', label: '关于我们' },
            ].map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  location.pathname === item.path
                    ? scrolled || !isHome
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-background-50/20 text-background-50'
                    : scrolled || !isHome
                      ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                      : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-700 hover:bg-background-100' : 'text-background-50 hover:bg-background-50/10'
            }`}
            aria-label="菜单"
          >
            <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3">
          <div className="flex flex-col gap-1">
            {[
              { path: '/', label: '首页' },
              { path: '/category/platform-recommend', label: '平台推荐' },
              { path: '/category/bonus-guide', label: '领取攻略' },
              { path: '/category/platform-review', label: '平台评测' },
              { path: '/category/newbie-faq', label: '常见问题' },
              { path: '/about', label: '关于我们' },
            ].map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === item.path
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}